require('./accountNewChequebookForm.scss');
// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const { OKLink } = require('commonsComponents/OKLink');
const OKInformativeList = require('components/rebrand/OKInformativeList/OKInformativeList');
const OKInformativeListItem = require('components/rebrand/OKInformativeListItem/OKInformativeListItem');
// @ helpers
const {FormattedText, formatText } = require('core/i18n').i18n;
const {ACCOUNT_NEW_CHECKBOOK_ID} = require('constants/operationTypes');
const { contactCenterClassName } = require('utilities/conditionals/conditionalClassname')
// @ components
const SignaturePattern = require('components/signaturePattern/signaturePattern').SignaturePattern;
const { OKSectionBox } = require('commonsComponents/OKSectionBox');
const SignaturePatternButton = require('components/signaturePattern/signaturePatternButton/signaturePatternButton');
const ContactCenterRender = require('components/conditionalRender/contactCenterRender')
const {
    ConfirmationScript,
    CONFIRMATION_SCRIPT_GREETING_WITH_SUMMARY,
    CONFIRMATION_SCRIPT_AGREEMENT
} = require('components/contactCenter/confirmScript/confirmationScript');
// @ constants
const {
    ACCOUNT_CHEQUEBOOK_NEW_DOCUMENT_NUMBERS,
    API_ENTERPRISE_NUMBER,
    API_CENTER
 } = require('constants/index');

class AccountNewChequebookForm extends React.Component {

    constructor(props) {
        super(props);
        this.handleRequestNewChequebook = this.handleRequestNewChequebook.bind(this);
    }

    handleRequestNewChequebook() {
        this.props.requestNewChequebook(this.props.accountId);
    }

    render() {
        const { accountId, immAdditionalInformation, immAccounts, immAccountNewChequebook } = this.props;
        const checkQuantity = ACCOUNT_CHEQUEBOOK_NEW_DOCUMENT_NUMBERS;
        const checkLanguage = formatText('accountCheques-checkLanguage');
        const exitLink = `/myprofile/accounts/${accountId}/cheques`;
        const title = formatText('accountCheques-requestCounterFoilConfirmation');
        const newProduct = immAccounts.getIn(['byId', accountId, 'newProduct']);
        const newContractNumber = immAccounts.getIn(['byId', accountId, 'newContractNumber']);
        const originAccount = API_ENTERPRISE_NUMBER + API_CENTER + newProduct + newContractNumber;
        const inProgress = immAccountNewChequebook.get('inProgress');
        const operative = formatText('operatives-requestCheckbook');

        const operationParams = {
            originAccount
        };

        let signaturePattern;

        if (immAdditionalInformation.get('hasBeenFetched')) {
            signaturePattern = (
                <SignaturePattern
                    operationType={ACCOUNT_NEW_CHECKBOOK_ID}
                    operationParams={operationParams}
                />
            );
        }

        const accountNewCheckboxClassName = contactCenterClassName('no-print-out', 'account-new-chequebook-form__footer')

        return (
            <OKSectionBox
                title={title}
                className="account-new-chequebook-form">
                <ContactCenterRender>
                    <ConfirmationScript
                        operative={operative}
                        confirmationType={CONFIRMATION_SCRIPT_GREETING_WITH_SUMMARY}
                    />
                </ContactCenterRender>
                <div className="account-new-chequebook-form__content">
                    <OKInformativeList columns={4}>
                        <OKInformativeListItem title="accountNewChequebook-checkQuantity">
                            <span className="account-new-chequebook-form__content-value">{checkQuantity}</span>
                        </OKInformativeListItem>
                        <OKInformativeListItem title="accountNewChequebook-checkLanguage">
                            <span className="account-new-chequebook-form__content-value">{checkLanguage}</span>
                        </OKInformativeListItem>
                    </OKInformativeList>
                    <ContactCenterRender>
                        <ConfirmationScript confirmationType={CONFIRMATION_SCRIPT_AGREEMENT} />
                    </ContactCenterRender>
                    {signaturePattern}
                </div>
                <footer className={accountNewCheckboxClassName}>
                    <div className="account-new-chequebook-form__cancel-link">
                        <OKLink
                            modifier="emphasize"
                            to={exitLink}
                        >
                            <FormattedText value="accountNewChequebook-cancel" />
                        </OKLink>
                    </div>
                    <div className="pull-right">
                        <SignaturePatternButton id="btnAccountIntervenersRemove" loading={inProgress} onClick={this.handleRequestNewChequebook} >
                            <FormattedText value="accountNewChequebook-requestNewChequebook" />
                        </SignaturePatternButton>
                    </div>
                </footer>
            </OKSectionBox>
        );
    }
}

AccountNewChequebookForm.propTypes = {
    requestNewChequebook: PropTypes.func,
    accountId: PropTypes.string.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immAccountNewChequebook: PropTypes.object.isRequired,
    immAdditionalInformation: PropTypes.object.isRequired
};

module.exports = AccountNewChequebookForm;
